<template>
  <div v-if="product">
    <h3>Local</h3>
    <dl>
      <dt>Local ID</dt>
      <dd v-text="product.local_id"></dd>
    </dl>
    <dl>
      <dt>Location</dt>
      <dd v-html="product.location.name"></dd>
    </dl>

    <hr class="border-top" />
    <h3>Product</h3>
    <dl>
      <dt>Product Name</dt>
      <dd v-html="product.name"></dd>
    </dl>
    <dl>
      <dt>Product Code</dt>
      <dd v-html="product.code"></dd>
    </dl>
    <dl>
      <dt>Manufacturer</dt>
      <dd v-text="product.manufacturer.name"></dd>
    </dl>
    <dl>
      <dt>Vendor</dt>
      <dd v-text="product.vendor.name"></dd>
    </dl>

    <hr class="border-top" />
    <h3>SDS</h3>
    <dl>
      <dt>SDS Number</dt>
      <dd v-text="product.sds_number"></dd>
    </dl>
    <dl>
      <dt>SDS Revision Date</dt>
      <dd v-text="product.sds_date"></dd>
    </dl>
    <dl>
      <dt>SDS Version</dt>
      <dd v-text="product.sds_version"></dd>
    </dl>
    <div v-if="product.eds">
      <hr class="border-top" />
      <h3>EDS</h3>
      <dl v-if="product.eds_date">
        <dt>EDS Revision Date</dt>
        <dd v-text="product.eds_date"></dd>
      </dl>
      <dl v-if="product.eds_version">
        <dt>EDS Version</dt>
        <dd v-text="product.eds_version"></dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: "SdsProductInfo",
  props: {
    product: {
      type: Object
    }
  }
};
</script>
